var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./partials/basics.j2"] = require( "./partials/basics.j2" );
dependencies["./partials/addstore.j2"] = require( "./partials/addstore.j2" );
dependencies["./partials/email-preferences.j2"] = require( "./partials/email-preferences.j2" );
dependencies["./partials/loyalty.j2"] = require( "./partials/loyalty.j2" );
dependencies["./partials/employee.j2"] = require( "./partials/employee.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/profile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"u-skip-anchor\" class=\"s-account o-row o-column o-extra-small--12 o-medium--9 o-large--10 c-profile\">\n\n    <div class=\"o-row\">\n\n        ";
if((runtime.memberLookup((runtime.memberLookup(((lineno = 4, colno = 24, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"employee")),"employeeId") && runtime.memberLookup((runtime.memberLookup(((lineno = 4, colno = 71, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"employee")),"employeeId") != "" && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors") == false) || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showEmployeeSignup") == true) {
output += "\n\n            ";
var t_1;
t_1 = true;
frame.set("showEmployeeSection", t_1, true);
if(frame.topLevel) {
context.setVariable("showEmployeeSection", t_1);
}
if(frame.topLevel) {
context.addExport("showEmployeeSection", t_1);
}
output += "\n\n        ";
;
}
else {
output += "\n\n            ";
var t_2;
t_2 = false;
frame.set("showEmployeeSection", t_2, true);
if(frame.topLevel) {
context.setVariable("showEmployeeSection", t_2);
}
if(frame.topLevel) {
context.addExport("showEmployeeSection", t_2);
}
output += "\n\n        ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") == "password" && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors")) {
output += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"passwordUpdateSuccess")) {
output += "\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    <div class=\"c-form__field has-success\" data-qa-account-edit-password-success>\n\n                        <div class=\"c-form-block\">\n\n                            <p class=\"c-form-block__p\">\n\n                                ";
output += runtime.suppressValue((lineno = 26, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-password-success",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                            </p>\n                        </div>\n\n                    </div>\n                </div>\n\n            ";
;
}
output += "\n\n        ";
;
}
output += "\n\n        <div class=\"o-column o-medium--12 u-margin-bottom c-account__page-intro c-profile__intro\">\n\n            <h1 class=\"c-account__h1\">\n\n                ";
output += runtime.suppressValue((lineno = 42, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-header",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n            </h1>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row c-profile__row\">\n\n        <div class=\"o-row o-column o-extra-small--12 o-large--6\">\n\n            ";
env.getTemplate("./partials/basics.j2", false, "account/templates/profile.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n        </div>\n\n        <div class=\"o-row o-column o-extra-small--12 o-large--6 c-store-result__favorite\">\n\n            ";
env.getTemplate("./partials/addstore.j2", false, "account/templates/profile.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row c-profile__row\">";
if(runtime.contextOrFrameLookup(context, frame, "showEmployeeSection") && (lineno = 68, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.myAccountConfig.showEmailPreferences"]))) {
var t_11;
t_11 = "o-extra-large--4";
frame.set("employeeConditionalColumns", t_11, true);
if(frame.topLevel) {
context.setVariable("employeeConditionalColumns", t_11);
}
if(frame.topLevel) {
context.addExport("employeeConditionalColumns", t_11);
}
;
}
else {
var t_12;
t_12 = "";
frame.set("employeeConditionalColumns", t_12, true);
if(frame.topLevel) {
context.setVariable("employeeConditionalColumns", t_12);
}
if(frame.topLevel) {
context.addExport("employeeConditionalColumns", t_12);
}
;
}
if((lineno = 78, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.myAccountConfig.showEmailPreferences"]))) {
output += "\n\n            <div class=\"o-row o-column o-extra-small--12 o-large--6 ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "employeeConditionalColumns"), env.opts.autoescape);
output += "\">\n                ";
env.getTemplate("./partials/email-preferences.j2", false, "account/templates/profile.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n            </div>\n\n        ";
})});
}
output += "\n\n        <div class=\"o-row o-column o-extra-small--12 o-large--6 ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "employeeConditionalColumns"), env.opts.autoescape);
output += "\">\n            ";
env.getTemplate("./partials/loyalty.j2", false, "account/templates/profile.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n        </div>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "showEmployeeSection")) {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12 o-large--6 ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "employeeConditionalColumns"), env.opts.autoescape);
output += "\">\n            ";
env.getTemplate("./partials/employee.j2", false, "account/templates/profile.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n        </div>\n\n        ";
})});
}
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/profile.j2"] , dependencies)